import Vue from 'vue'
import {Cookies} from  '../utils/Cookies'
import cookies from 'js-cookie'
import Router from 'vue-router'
const password = ()=> import ("@/views/pc/password/index")
const passwordM = ()=> import ("@/views/mobile/password/index")
const Layout = () => import ("@/components/index")
const fileList = () => import ("@/views/pc/main/index")
const fileListM = ()=> import ("@/views/mobile/main/index")
const NotFoundM =() =>import("@/views/mobile/main/components/notfound")
const loginM =() =>import("@/views/mobile/main/components/login")
const deviceM =() =>import("@/views/mobile/main/components/devicelist")
const contrycodeM =() =>import("@/views/mobile/main/components/contrycode")
const checkcodeM =() =>import("@/views/mobile/main/components/checkcode")
const profileM =() =>import("@/views/mobile/main/components/profile")
const reportM =() =>import("@/views/mobile/main/components/report")
const pdfM =() =>import("@/views/mobile/main/components/pdf")

const NotFound =() =>import("@/views/pc/main/components/notfound")
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes =  [
  {
    path: '/',
 component: Layout,
 name:'gen',
 children:[
  {
    path:'share/',
    name: 'share',
    component: Layout,
    meta: {
          title: "雷克沙时光机分享",
           keepAlive:false
         }
      
  }



 ] }
  ]
  let asyncRouteP= 
    {
      path: 's/:shareKey',
      name: 's',
      component: Layout,
      
      meta: {
        title: "雷克沙时光机分享",
        keepAlive:false
      },
      children:[
        {
          path: '',
          name: 'filelist',
          component: fileList,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        {
          path: 'PCm',
          name: 'password',
          component: password,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        {
          path: 'notfound',
          name: 'notfound',
          component: NotFound,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        {
          path: "*",
          redirect:(to,from)=>{
            console.log(to);
            return { name: 'filelist', params: {shareKey : to.params.shareKey} }
          }
      }
   
        
      ]
  }
  let asyncRouteM=
    {
      path: 's/:shareKey',
      name: 'ss',
      component:Layout ,
      redirect:{name:'filelist'},
      meta: {
        title: "雷克沙时光机分享",
        keepAlive:false
      },
      children:[
        {
          path: '',
          name: 'filelist',
          component: fileListM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        {
          path: 'm',
          name: 'passwordM',
          component: passwordM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
      
        {
          path: 'pdf',
          name: 'pdf',
          component: pdfM,
          meta: {
            title: "雷克沙时光机分享",
             keepAlive:true
          },
        },
        {
          path: 'notfound',
          name: 'notfound',
          component: NotFoundM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
        //登录账号
        {
          path: 'login',
          name: 'login',
          component: loginM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
        // 设备列表页
        {
          path: 'device',
          name: 'device',
          component: deviceM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        //选择国家码
        {
          path: 'contrycode',
          name: 'contrycode',
          component: contrycodeM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
        //验证码
        {
          path: 'checkcode',
          name: 'checkcode',
          component: checkcodeM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:false
          },
        },
        //用户信息
        {
          path: 'profile',
          name: 'profile',
          component: profileM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
        //举报
        {
          path: 'report',
          name: 'report',
          component: reportM,
          meta: {
            title: "雷克沙时光机分享",
            keepAlive:true
          },
        },
        {
          path: "*",
          redirect:(to,from)=>{
            console.log(to,from);
            return { name: 'filelist', params: {shareKey : to.params.shareKey} }
          }
      }
        ]
    }
let asyncRouter={}
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  asyncRouter={...asyncRouteM}
} else {
  asyncRouter={...asyncRouteP}
  }
  const router = new Router({
    mode: 'history',
    routes,
  });
  window.location.pathname.includes('/share')? router.addRoute('share',asyncRouter): router.addRoute('gen',asyncRouter)

  router.beforeEach((to, from, next) => {
    let { title } = to.meta;
    document.title = title; // 动态配置每个页面的标题
      //    解决旧链接的shareKey
      const params = new URLSearchParams(window.location.search)
      if(from.path=='/'&&to.name=='filelist'){
        cookies.set('localhome',window.location.pathname)
        if(params.get('shareKey')){
            Cookies.set('shareKey',params.get('shareKey'),{path: window.location.pathname})
            to.params.shareKey=params.get('shareKey')
        }else
        {
            const { shareKey } =to.params
            shareKey?shareKey!== Cookies.get('shareKey')? Cookies.set('shareKey',shareKey):'':''
           
        } 
        
      }
    next()
  })


export default router




// WEBPACK FOOTER //
// ./src/router/index.js